import Tracker from './Tracker';

const AITracker = new Tracker('AI', {
	ACCEPTED_CONTRACT: 'acceptedTerms',
	GENERATE_MAIL_TEMPLATE: 'generateMailTemplate',
	GENERATE_AGENDA: 'generateAgenda'
});

export default AITracker;
